// extracted by mini-css-extract-plugin
module.exports = {"menu":"_5c4871d","option":"_538308d"};